import {createFeature, createReducer, createSelector, on} from '@ngrx/store';
import {EntityState, EntityAdapter, createEntityAdapter, Dictionary} from '@ngrx/entity';
import {Update} from "@ngrx/entity";
import {TaskModel} from "../../models/task.model";
import {TasksActions, TasksAPiActions, TasksChannelActions} from "./tasks.actions";
import {Service} from "../../../deliveries/models/service.model";

export interface TasksState extends EntityState<TaskModel> {
}

const adapter: EntityAdapter<TaskModel> = createEntityAdapter<TaskModel>();

const initialState: TasksState = adapter.getInitialState();

const reducer = createReducer(
  initialState,

  on(TasksChannelActions.notificationReceived, (state, {notification}) => {

    if ((state.entities[notification.id]?.updatedAt || 0) < notification.updatedAt) {
      const changes: Update<Service> = {
        id: notification.id,
        changes: {...notification}
      }
      return adapter.updateOne(changes, state);
    } else {
      return state;
    }

  }),

  on(TasksAPiActions.getTasksSuccess, (state, {tasks}) => adapter.setMany(tasks, state)),

  on(TasksActions.setTasks, (state, {tasks}) => {
    return adapter.setMany(tasks, state);
  }),

  on(TasksActions.removeTasks, (state, {ids}) => adapter.removeMany(ids, state)),

  on(TasksActions.removeAll, (state) => adapter.removeAll(state))
);

export const tasksFeature = createFeature({
  name: 'Tasks',
  reducer,
  extraSelectors: ({selectTasksState, selectEntities}) => ({
    ...adapter.getSelectors(selectTasksState),
    selectTasks: (taskIds: string[]) => createSelector(
      selectEntities,
      (entities: Dictionary<TaskModel>) => {
        return taskIds.map(taskId => entities[taskId]);
      },
    ),
    selectTask: (id: string) => createSelector(
      selectEntities,
      (entities: Dictionary<TaskModel>) => entities ? entities[id] : undefined,
    )
  })
});
